<template>
  <div class="wk-icon-div">
    <i class="wk wk-cancel" v-if="type == 'cancel'"></i>
    <i class="wk wk-refresh" v-if="type == 'refresh'"></i>
    <i class="wk wk-refresh1" v-if="type == 'refresh1'"></i>
    <i class="wk wk-export" v-if="type == 'export'"></i>
    <i class="wk wk-search" v-if="type == 'search'"></i>
    <i class="wk wk-table" v-if="type == 'table'"></i>
    <i class="wk wk-add2" v-if="type == 'add2'"></i>
    <i class="wk wk-reduce" v-if="type == 'reduce'"></i>
  </div>
</template>

<script>

export default {
  name: 'XrIcon',
  props: {
    type: String
  }
}
</script>

<style lang="scss" scoped>
  .wk-icon-div{display: inline;}
  .wk{cursor: pointer;}
  .wk-cancel{color: #1E90FF;}
  .wk-refresh{color: #FFA500;}
  .wk-refresh1{color: #1E90FF;}
  .wk-export{color: #1E90FF;}
  .wk-search{color: green;}
  .wk-table{color: #1E90FF;}
</style>



// WEBPACK FOOTER //
// src/components/XrIcon/index.vue